  (function() {
    /* Message rotation is now 100% CSS (see the keyframes in the
       <style> above): both messages render and the browser alternates them on a
       6s loop. There is no JS active index, rotation interval, or class toggling
       here, nothing that can fight the animation or snap the bar back to
       message 1. This script only updates the countdown digits and the
       session-stable shopper count in the shipping message. */
    var shopperStorageKey = 'cwAnnouncementShopperCount';

    function getSessionShopperCount() {
      var min = 150;
      var max = 190;
      var stored;

      try {
        stored = window.sessionStorage && window.sessionStorage.getItem(shopperStorageKey);
      } catch (error) {
        stored = null;
      }

      var parsed = parseInt(stored, 10);
      if (parsed >= min && parsed <= max) {
        return parsed;
      }

      var generated = Math.floor(Math.random() * (max - min + 1)) + min;

      try {
        if (window.sessionStorage) {
          window.sessionStorage.setItem(shopperStorageKey, String(generated));
        }
      } catch (error) {
        // Ignore storage errors; the generated value still renders for this load.
      }

      return generated;
    }

    function initCWAnnouncement(root) {
      if (!root) return;

      var shopperCountEls = Array.prototype.slice.call(root.querySelectorAll('[data-cw-shopper-count]'));
      if (shopperCountEls.length) {
        var shopperCount = getSessionShopperCount();

        shopperCountEls.forEach(function(element) {
          element.textContent = shopperCount;

          var message = element.closest && element.closest('.cw-announcement__message--shipping-proof');
          if (message) {
            message.classList.add('is-ready');
          }
        });

        if (!root._cwDrift) {
          root._cwDrift = window.setInterval(function() {
            var current = getSessionShopperCount();
            var next = current + (Math.floor(Math.random() * 5) - 2);
            if (next < 150) next = 150;
            if (next > 190) next = 190;
            try { if (window.sessionStorage) window.sessionStorage.setItem(shopperStorageKey, String(next)); } catch (error) {}
            shopperCountEls.forEach(function(element) { element.textContent = next; });
          }, 9000);
        }
      }

      /* Card rotation: every card in turn, first card first, interval from the
         section setting. Pauses while the pointer is over the bar or the tab is
         hidden. One index, one timer, so no card shows out of order. */
      var messages = root.querySelector('.cw-announcement__messages');
      var cards = messages ? Array.prototype.slice.call(messages.querySelectorAll('.cw-announcement__message')) : [];
      if (messages && cards.length > 1 && !messages._cwRotator) {
        var interval = parseInt(messages.getAttribute('data-cw-interval'), 10) || 4500;
        var index = 0;
        var paused = false;
        messages.classList.add('is-js');
        cards[0].classList.add('is-active');
        messages._cwRotator = window.setInterval(function() {
          if (paused || document.hidden) return;
          cards[index].classList.remove('is-active');
          index = (index + 1) % cards.length;
          cards[index].classList.add('is-active');
        }, interval);
        root.addEventListener('mouseenter', function() { paused = true; });
        root.addEventListener('mouseleave', function() { paused = false; });
      }

      var countdowns = Array.prototype.slice.call(root.querySelectorAll('[data-cw-countdown]'));

      countdowns.forEach(function(countdown) {
          var resetTime = (countdown.getAttribute('data-reset-time') || '00:00:00').trim();
          var resetTimezone = (countdown.getAttribute('data-reset-timezone') || 'America/Toronto').trim();

          /*
            12-hour global reset countdown:
            This is not a visitor/session timer. It counts down to the next real
            reset point in the timezone below, the configured reset time and again
            12 hours later, then automatically rolls into the next 12-hour cycle.
            Max shown is 12 hours; refreshing the page will NOT reset it.
          */

          if (!/^\d{2}:\d{2}(:\d{2})?$/.test(resetTime)) {
            resetTime = '00:00:00';
          }

          if (/^\d{2}:\d{2}$/.test(resetTime)) {
            resetTime = resetTime + ':00';
          }

          var resetParts = resetTime.split(':').map(function(part) {
            return parseInt(part, 10);
          });

          var resetHour = resetParts[0] || 0;
          var resetMinute = resetParts[1] || 0;
          var resetSecond = resetParts[2] || 0;

          var daysEl = countdown.querySelector('[data-cw-days]');
          var hoursEl = countdown.querySelector('[data-cw-hours]');
          var minutesEl = countdown.querySelector('[data-cw-minutes]');
          var secondsEl = countdown.querySelector('[data-cw-seconds]');

          function getTimeZoneParts(date, timeZone) {
            var formatter = new Intl.DateTimeFormat('en-US', {
              timeZone: timeZone,
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false
            });

            var parts = formatter.formatToParts(date).reduce(function(acc, part) {
              if (part.type !== 'literal') {
                acc[part.type] = part.value;
              }
              return acc;
            }, {});

            return {
              year: parseInt(parts.year, 10),
              month: parseInt(parts.month, 10),
              day: parseInt(parts.day, 10),
              hour: parseInt(parts.hour, 10),
              minute: parseInt(parts.minute, 10),
              second: parseInt(parts.second, 10)
            };
          }

          function getTimeZoneOffsetMs(date, timeZone) {
            var parts = getTimeZoneParts(date, timeZone);
            var asUtc = Date.UTC(
              parts.year,
              parts.month - 1,
              parts.day,
              parts.hour,
              parts.minute,
              parts.second
            );

            return asUtc - date.getTime();
          }

          function zonedTimeToUtcMs(year, month, day, hour, minute, second, timeZone) {
            var utcGuess = Date.UTC(year, month - 1, day, hour, minute, second);
            var offset = getTimeZoneOffsetMs(new Date(utcGuess), timeZone);
            var utc = utcGuess - offset;

            offset = getTimeZoneOffsetMs(new Date(utc), timeZone);
            return utcGuess - offset;
          }

          function addOneDayInZone(parts) {
            var nextNoonUtc = Date.UTC(parts.year, parts.month - 1, parts.day + 1, 12, 0, 0);
            return getTimeZoneParts(new Date(nextNoonUtc), resetTimezone);
          }

          /* 12-hour cycle: the sale "resets" twice a day, at the configured
             reset time and again 12 hours later, so the visible countdown never
             exceeds 12 hours. It counts down from 12:00:00 to 0, then restarts.
             zonedTimeToUtcMs normalizes hour/day overflow, so resetHour + 12 and
             nowParts.day + 1 are handled correctly across midnight/month bounds. */
          function getNextDeadlineMs() {
            var now = new Date();
            var nowMs = now.getTime();
            var nowParts = getTimeZoneParts(now, resetTimezone);
            var next = null;

            for (var dayOffset = 0; dayOffset <= 1; dayOffset++) {
              for (var half = 0; half < 2; half++) {
                var candidate = zonedTimeToUtcMs(
                  nowParts.year,
                  nowParts.month,
                  nowParts.day + dayOffset,
                  resetHour + (half * 12),
                  resetMinute,
                  resetSecond,
                  resetTimezone
                );

                if (candidate > nowMs && (next === null || candidate < next)) {
                  next = candidate;
                }
              }
            }

            return next !== null ? next : (nowMs + 12 * 60 * 60 * 1000);
          }

          function formatUnit(number) {
            return number < 10 ? '0' + number : String(number);
          }

          function render() {
            var deadlineMs = getNextDeadlineMs();
            var remaining = Math.max(Math.floor((deadlineMs - Date.now()) / 1000), 0);

            var d = Math.floor(remaining / 86400);
            var h = Math.floor((remaining % 86400) / 3600);
            var m = Math.floor((remaining % 3600) / 60);
            var s = remaining % 60;

            if (daysEl) daysEl.textContent = formatUnit(d);
            if (hoursEl) hoursEl.textContent = formatUnit(h);
            if (minutesEl) minutesEl.textContent = formatUnit(m);
            if (secondsEl) secondsEl.textContent = formatUnit(s);

            countdown.classList.remove('is-expired');
          }

          /* One interval per countdown element. Clear any prior one first so a
             Shopify theme-editor section reload can never stack timers. This
             ONLY writes the H/M/S digits, it never touches the messages. */
          if (countdown._cwCountdownTimer) {
            window.clearInterval(countdown._cwCountdownTimer);
          }
          render();
          countdown._cwCountdownTimer = window.setInterval(render, 1000);
        });
    }

    function initAllCWAnnouncements(scope) {
      var context = (scope && scope.querySelectorAll) ? scope : document;
      if (context.matches && context.matches('[data-cw-announcement]')) {
        initCWAnnouncement(context);
      }
      context.querySelectorAll('[data-cw-announcement]').forEach(initCWAnnouncement);
    }

    initAllCWAnnouncements(document);

    /* Re-init the reloaded section in the theme editor so its countdown keeps
       ticking. Rotation needs nothing here, it is pure CSS. */
    document.addEventListener('shopify:section:load', function(event) {
      initAllCWAnnouncements(event && event.target);
    });
  })();
  (function() {
    function forceCWAnnouncementVisible() {
      var bar = document.querySelector('[data-cw-announcement]');
      if (!bar) return;

      bar.style.position = 'fixed';
      bar.style.top = '0';
      bar.style.left = '0';
      bar.style.right = '0';
      bar.style.zIndex = '9999';
      bar.style.display = 'block';
      bar.style.opacity = '1';
      bar.style.visibility = 'visible';
      bar.style.transform = 'none';
      bar.removeAttribute('hidden');
      bar.setAttribute('aria-hidden', 'false');
      bar.classList.remove('hidden', 'is-hidden', 'announcement-hidden');
    }

    forceCWAnnouncementVisible();
    window.addEventListener('scroll', forceCWAnnouncementVisible, { passive: true });
    window.addEventListener('resize', forceCWAnnouncementVisible, { passive: true });
    document.addEventListener('shopify:section:load', forceCWAnnouncementVisible);
  })();
